export enum CustomerIOEvents {
  GAME_CLOSED = 'game_closed',
  PWA_INSTALLED = 'pwa_installed', // Agreed to use opened
}
